import type { FC } from 'react';
import { useGetInternalAuditById } from 'src/hooks/queries';

type Props = {
  internalAuditId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ internalAuditId }) => {
  if (!internalAuditId) {
    throw new Error('Missing internalAuditId param');
  }
  const { data } = useGetInternalAuditById(internalAuditId);

  return <>{data?.internal_audit_entity?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
